import React, { FC, createContext, ReactNode, ReactElement } from 'react';

interface IThemeStore {
    theme: any;
    setTheme: any;
}

export const ThemeStoreContext = createContext<IThemeStore>({} as IThemeStore);

type ThemeStoreComponent = FC<{
    theme: any;
    setTheme: any;
    children: ReactNode;
}>;

export const ThemeStoreProvider: ThemeStoreComponent = ({
    children,
    theme,
    setTheme,
}): ReactElement => {
    return (
        <ThemeStoreContext.Provider value={{ theme, setTheme }}>
            {children}
        </ThemeStoreContext.Provider>
    );
};
